export default "__VITE_PUBLIC_ASSET__35db04e8__"